"use client";

import React from "react";

import { iconColor } from "./colors";
import { createSVGIcon } from "./createSVGIcon";
import { iconCls } from "./tracking";

/**
 * NOTE: manually added from a source SVG, not synced from Figma. viewBox is
 * kept at the source asset's native 16x16 grid rather than this package's
 * usual 24x24 grid.
 * @optimized using svgo:^3.3.4
 */
export const TopShopTrophy = createSVGIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M14 7.853c0 1.54-.63 3.023-1.759 4.11a6.06 6.06 0 0 1-2.933 1.561c1.28.383 2.29 1.31 2.692 2.476H4c.402-1.17 1.407-2.095 2.687-2.477a6.1 6.1 0 0 1-2.933-1.56A5.7 5.7 0 0 1 2 7.854V0h12zM8.098 2.61a.104.104 0 0 0-.195.001l-.721 1.873a.104.104 0 0 1-.128.064l-1.88-.59c-.09-.029-.168.071-.121.155L6.03 5.86A.11.11 0 0 1 6 6.002L4.379 7.141c-.078.055-.05.179.043.194l1.943.304a.11.11 0 0 1 .09.114L6.31 9.762c-.008.096.105.152.174.086L7.93 8.48a.103.103 0 0 1 .141 0l1.444 1.368c.07.066.182.01.174-.086l-.143-2.01a.11.11 0 0 1 .089-.113l1.942-.304c.094-.015.122-.14.044-.194L10 6a.11.11 0 0 1-.031-.14l.98-1.749c.046-.084-.031-.183-.122-.155l-1.879.59a.104.104 0 0 1-.128-.063z"
    fill="currentColor"
  />,
  "TopShopTrophy",
  {
    // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
    viewBox: "0 0 16 16",
    fill: "none",
    color: iconColor.primary,
    className: iconCls(),
  }
);
